import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { blankBoat } from '../../TestData';
import { BoatDetails } from './BoatDetails';
import * as Icons from 'react-bootstrap-icons';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../app/store';
import { add } from './boatListSlice';
import { BoatDetailsCard } from './BoatDetailsCard';


export function HandicapBoatList() {
  const boatGroupList = useSelector((state: RootState) => state.boatList.boatGroupList);
  const currentGroupId = useSelector((state: RootState) => state.boatList.currentGroupId);
  const dispatch: AppDispatch = useDispatch();

  const boatGroup = boatGroupList.find((g) => g.id === currentGroupId);

  function onClick() {
    const newBoat: BoatDetails = blankBoat();
    console.log('HandicapBoatList onClick', newBoat);
    dispatch(add(newBoat));
  }

  console.log('HandicapBoatList.render', boatGroup);

  function cardsForGroup() {
    return (<Row xs={1} sm={2} md={3} lg={4} xl={5} xxl={6} className="g-4">
      {boatGroup?.boatDetails.map((boat: BoatDetails) => <Col key={boat.id}>
        <BoatDetailsCard baseBoat={boat.id === boatGroup?.baseBoatId} boat={boat} />
      </Col>)}
      <Col key='add'>
        <Card>
          <Card.Body onClick={onClick} className='cursor-pointer'>
            <Card.Text>
              <Icons.PlusLg size="2em" />
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
    </Row>);
  }

  return <Container>
    {boatGroup ? cardsForGroup() : <p>No group available for boats.<br />Please select a group</p>}
  </Container>;
}
